import { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import * as actions from '../../../store/slices'
import { useParams } from 'react-router-dom'
import { SEMAGLYN } from '../../../constants/sema-constants'
import { getUrlParams } from '../../../utils/helpers/common'

const useGetSemaLandingPage = () => {
  const dispatch = useDispatch()
  const { variant } = useParams()
  const params = getUrlParams()
  const buttonRef = useRef(null)
  const [showStickyButton, setShowStickyButton] = useState(false)
  const { semaLandingPage } = useSelector((state) => state.landingPage)
  const fetchSemaLandingPage = (payload = {}) => {
    dispatch(
      actions.fetchSemaLandingPageRequest({
        ...payload,
        ...params,
      }),
    )
  }
  useEffect(() => {
    fetchSemaLandingPage({ programType: variant || SEMAGLYN })
  }, [])

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY || document.documentElement.scrollTop
      const scrollHeight =
        document.documentElement.scrollHeight - window.innerHeight
      const scrollPercentage = (scrollTop / scrollHeight) * 100

      // Show sticky button when page is scrolled 20% or more
      setShowStickyButton(scrollPercentage >= 20)
    }

    window.addEventListener('scroll', handleScroll)
    // Check initial scroll position
    handleScroll()

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])
  return {
    buttonRef,
    semaLandingPage,
    fetchSemaLandingPage,
    showStickyButton,
    setShowStickyButton,
  }
}

export default useGetSemaLandingPage
